import {
  downloadConstants
} from "../../actions/download/index";

export default function download(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState =
    typeof state === "undefined"
      ? { status: { error: false, started: false, ended: false } }
      : state;
  switch (type) {
  case downloadConstants.DOCUMENT_DOWNLOAD_RESET:
    return { status: { error: false, started: false, ended: false } };
  case downloadConstants.DOCUMENT_DOWNLOAD_START:

    return { status: { error: false, started: true, ended: false }, progress: payload.loadedSize };
  case downloadConstants.DOCUMENT_DOWNLOAD_SUCCESS:
    return {
      status: { error: false, started: false, ended: true },
      content: payload.data.content
        ? payload.data.content
        : payload.data.encodedContent,
      filename: payload.data.filename
    };
  case downloadConstants.DOCUMENT_DOWNLOAD_ERROR:
    return { status: { error: true, started: false, ended: false } };
  default:
    return defaultState;
  }
}
